import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import * as api from "../../../services/apiService";
import "./FormDashboard.scss";

function FormDashboard() {
  const [forms, setForms] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  // Function to refresh data
  async function fetchData() {
    try {
      const response = await api.getForms();
      if (response.ok) {
        const data = await response.json();
        setForms(data);
      }
    } catch (err) {
      console.error(err);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  // Make Delete Work
  async function handleDelete(id) {
    if (window.confirm("Ești sigur că vrei să ștergi acest formular?")) {
      try {
        await api.deleteForm(id);
        fetchData(); // Refresh list after delete
      } catch (error) {
        console.error("Delete failed", error);
      }
    }
  }

  const filteredForms = forms.filter(f => 
    f.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div id="formDashboard" className="">
      <div className="d-flex justify-content-between align-items-center p-4">
        
        <div className="d-flex gap-2 w-50">
            <input 
                type="search" 
                className="form-control text-black rounded px-3 py-2" 
                placeholder="Căutare..." 
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
            />
            <button className="btn text-white px-4 rounded">
                Căutare
            </button>
        </div>

        <Link to="/dashboard/forms/create" className="btn text-white">
          Adaugă Formular
        </Link>
      </div>

      <h3 className="mb-3 text-white p-4">Formulare</h3>

      <div className="overflow-x-auto rounded">
        <table className="table table-dark table-hover mb-0 align-middle">
            <thead className="table-header">
                <tr>
                    <th className="py-3 ps-4">ID</th>
                    <th className="py-3">Nume Formular</th>
                    <th className="py-3">Link</th>
                    <th className="py-3 pe-4 text-end">Acţiuni</th>
                </tr>
            </thead>
            <tbody>
                {filteredForms.map((row) => (
                    <tr key={row.id}>
                        <td className="ps-4">{row.id}</td>
                        <td className="fw-bold">{row.name}</td>
                        <td>
                            <a 
                                href={row.link} 
                                target="_blank" 
                                rel="noreferrer" 
                                className="text-info text-decoration-none text-truncate d-inline-block" 
                                style={{ maxWidth: "500px" }}
                            >
                                {row.link}
                            </a>
                        </td>
                        <td className="pe-4">
                            <div className="actions-cell">
                                <span 
                                    className="p-1 rounded" 
                                    onClick={() => handleDelete(row.id)}
                                    title="Șterge"
                                >
                                    <img src="/images/delete.png" alt="Delete" className="icon red" />
                                </span>

                                <Link 
                                    to={`/dashboard/forms/edit/${row.id}`} 
                                    className="p-1 rounded"
                                    title="Editează"
                                >
                                    <img src="/images/edit.png" alt="Edit" className="icon blue" />
                                </Link>
                            </div>
                        </td>
                    </tr>
                ))}
                {filteredForms.length === 0 && (
                    <tr>
                        <td colSpan="4" className="text-center p-5 text-white">
                            Nu s-au găsit formulare.
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
      </div>
    </div>
  );
}

export default FormDashboard;